import React from 'react';
import cn from 'classnames';
import styles from './orderItemDetail.module.scss';
import { LABEL, CUSTOM_MESSAGES } from '../../veriables';

const Modal = ({ isOpen, toggleModal, onConfirm, children, customClass }) => {
  return (
    <div className="container">
      {!children ? (
        <div className={cn('modal', isOpen ? 'fade show d-block' : 'fade')}>
          <div
            className={cn('modal-dialog modal-dialog-centered', customClass)}
            role="document"
          >
            <div className="modal-content od-app-background-color background-primary od-text-primary text-primary">
              <div className="card">
                <div className="p-10">
                  <div className="col text-right btn-as-text color-secondary">
                    <div
                      className="icon-od fs-12 icon-od-close"
                      role="presentation"
                      onClick={toggleModal}
                    />
                  </div>
                </div>
                <div className="mx-0 justify-content-center align-items-center text-center">
                  <div className="fs-18 fw-600 text-center mt-10 p-10 pt-0">
                    {CUSTOM_MESSAGES().POPIN_CONFIRM_MSG}
                  </div>
                  <div className="row mt-20 mb-20 justify-content-center align-items-center text-center">
                    <button
                      type="button"
                      className="mr-20 btn btn-secondary col-4"
                      onClick={toggleModal}
                    >
                      {LABEL().NO}
                    </button>
                    <button
                      type="button"
                      className="ml-20 btn btn-primary btn-ripple col-4"
                      onClick={onConfirm}
                    >
                      {LABEL().YES}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className={cn('modal', isOpen ? 'fade show d-block p-0' : 'fade')}>
          <div
            className={cn('modal-dialog modal-dialog-centered', customClass)}
            role="document"
          >
            <div
              className={cn(
                styles.modalHeight,
                'modal-content od-app-background-color od-text-primary text-primary'
              )}
            >
              {children}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default React.memo(Modal);
